import { FC, Fragment } from 'react';

interface LoaderPointsProps {
  isLoading?: boolean;
}

const LoaderPoints: FC<LoaderPointsProps> = ({ isLoading }) => {
  return (
    <Fragment>
      {isLoading && (
        <div className="loader-points">
          <span></span>
          <span></span>
          <span></span>
        </div>
      )}
    </Fragment>
  );
};

export default LoaderPoints;
